import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import WIPBatchList from "../components/WIP/WIPBatchList.component";
import {
  setSelectedReportId,
  getWipItemsByBatch,
  getWipReportById,
} from "../reducers/wip.reducer";
import { selectWipReports } from "../selectors/wip.selector";
import { selectOrganisationId } from "../selectors/login.selector";

/**
 * WIP Batch View Page
 * Allows users to view WIP items by batch update date
 */
/**
 * WIP Batch View Page
 * Allows users to view WIP items by WIP report ID (wipId)
 * Route: /wip/:wipId
 */
const WIPBatchViewPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { wipId } = useParams(); // Get wipId from URL params
  const reports = useSelector(selectWipReports);
  const organisationId = useSelector(selectOrganisationId);

  // Get report details for display
  const currentReport = reports.find((report) => report._id === wipId);

  // Fetch report data if missing
  useEffect(() => {
    if (wipId && organisationId && !currentReport) {
      console.log("Report data not found, fetching...");
      dispatch(getWipReportById({ wipReportId: wipId }));
    }
  }, [wipId, organisationId, currentReport, dispatch]);

  // Fetch data on mount using wipId from URL params
  useEffect(() => {
    if (wipId) {
      // Set selected report in Redux
      dispatch(setSelectedReportId(wipId));
      // Fetch items for this report
      dispatch(getWipItemsByBatch({ batchUpdateId: wipId }));
    }
  }, [wipId, dispatch]);

  const reportName = currentReport?.file?.filename || "Loading...";

  return (
    <Box
      sx={{
        height: "100vh",
        bgcolor: "#f5f7fa",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* <Box sx={PageStyles.containerBoxExceptNavbar}>
        <Box sx={PageStyles.firstSectionWithBreadcrumbsAndName}>
          <TopBreadcrumbs />
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography gutterBottom sx={PageStyles.name}>
                View WIP items by batch update date
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Divider /> */}
      <Box
        sx={{
          width: "100%",
          px: 2,
          pt: 3,
          flexShrink: 0,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 3,
          }}
        >
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/wip")}
            variant="outlined"
            sx={{
              textTransform: "none",
              borderRadius: "12px",
              borderColor: "#e0e0e0",
              color: "#344054",
              "&:hover": {
                borderColor: "#4B68D4",
                backgroundColor: "#f5f7fa",
              },
            }}
          >
            Back
          </Button>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <CalendarTodayIcon sx={{ fontSize: 32, color: "#4B68D4" }} />
            <Box>
              <Typography
                variant="h4"
                sx={{ fontWeight: 700, color: "#1a1a1a" }}
              >
                {reportName}
              </Typography>
              {currentReport && (
                <Typography variant="body2" color="text.secondary">
                  {currentReport.supplierName} • {currentReport.season} •{" "}
                  {currentReport.totalItems || 0} items
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Batch Items List - Takes up remaining space */}
      <Box
        sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
      >
        <WIPBatchList readOnly={true} />
      </Box>
    </Box>
  );
};

export default WIPBatchViewPage;
